module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACAAgMAAAC+UIlYAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAACVBMVEX///9miMwAAAAd8e/3AAAAAXRSTlMAQObYZgAAAAFiS0dEAmYLfGQAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfgBwYICxJThcvVAAAAOElEQVRYw+3XsQkAIBADwCz5+69iJWIlfPE2lyqEWyCpRzIBsnPaNQIAAAAAAAAAAAAA0Af/v/8CnqD0YSUSAwUAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTYtMDctMDZUMDg6MTE6MTgrMDI6MDAwJAYBAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE2LTA3LTA2VDA4OjExOjE4KzAyOjAwQXm+vQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/tab.png
// module id = dMwt
// module chunks = 1